import React, { useState, useContext, useEffect } from 'react';
import './Charge.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import Fade from '@/v2/components/atoms/Fade';
import TextBottom from '@/v2/components/atoms/TextBottom';
import Dialog from '@/v2/components/layouts/Dialog';
import Header from '@/v2/components/application/Header';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { ConnectivityContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';
import { ClearMemory } from '@/v2/components/utils/DeviceUtils';
import { timeout, clearTimeouts } from '@/v2/components/utils/Timeout';

let videoController = null;

const STATE = {
    intro: 'intro',
    cta: 'cta',
    transitionNext: 'transitionNext',
};

const videoReady = (controller, onReady) => {
    videoController = controller;
    onReady();
};

const play = () => {
    videoController.Play();
};

const Charge = ({ isActive, data, onFinished, onReady }) => {
    const [state, setState] = useState(STATE.intro);
    const [showFade, setShowFade] = useState(false);
    const { dispatch: momentDispatch } = useContext(MomentStateContext);
    const [{ disclaimer }] = useContext(ConnectivityContext);
    const [showTextBottom, setShowTextBottom] = useState('out');
    const [textBottom, setTextBottom] = useState(null);

    const activate = () => {
        timeout(() => {
            setState(STATE.cta);
        }, 2700);
    };

    const videoFinished = () => {
        timeout(() => {
            setShowFade(true);
            timeout(() => {
                onFinished();
                setState(STATE.transitionNext);
                ClearMemory();
            }, 1000);
        }, 2000);
    };

    useEffect(() => () => clearTimeouts(), []);

    useEffect(() => {
        if (isActive) {
            activate(setState);
            timeout(() => {
                if (textBottom === null) {
                    setTextBottom(data.dialogbox[0].label.bottomText);
                    setShowTextBottom('in');
                }
            }, 700);
        }
    }, [isActive]);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
        }
    }, [isActive, videoController]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, onReady),
        autoPlay: false,
        onFinished: () => videoFinished(onFinished, setShowFade, setState),
    };

    const handleCta = () => {
        setShowTextBottom('out');
        play();
        timeout(() => {
            setTextBottom(data.dialogbox[1].label.bottomText);
            setShowTextBottom('in');
        }, 700);
    };

    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} dark /> : '';
    return (
        <div className="Charge">
            <VideoSimple offsetRatio={1.9} offset={100} src={data.video} options={options} />
            <Header show={isActive} hideLogo dark />
            {state !== STATE.transitionNext && (
                <>
                    <TextBottom component="h4" animate={showTextBottom} color="black" background="light">
                        {textBottom}
                    </TextBottom>
                    {state === STATE.cta && (
                        <div className="Charge__dialogbox">
                            <Dialog
                                bodyText={data.dialogbox[0].label.body}
                                bodyTextAfter={data.dialogbox[1].label.body}
                                bodyTextHeader={data.dialogbox[0].label.title}
                                switchLabelAfter={data.dialogbox[1].label.cta}
                                switchLabelBefore={data.dialogbox[0].label.cta}
                                variant="charging"
                                onButtonClick={handleCta}
                            />
                        </div>
                    )}
                </>
            )}
            <Fade show={showFade} light cover disableFadeOut />
            {disclaimerContent}
        </div>
    );
};

export default Charge;
